import escapeRegex from './escapeRegex';
export default (function (search) {
  let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ig';
  return new RegExp(escapeRegex(search) || '', flags);
});
//# sourceMappingURL=safeSearchRegex.js.map